// extracted by mini-css-extract-plugin
export default {"wrapper":"userLayout_wrapper__wCl-k","fadeDown":"userLayout_fadeDown__WRlI7"};